(function() {
  function trackPromotionEvent(event_name, element) {
    var promoData = {
      promotion_id: element.getAttribute('data-promo-id'),
      promotion_name: element.getAttribute('data-promo-name'),
      creative_name: element.getAttribute('data-promo-creative'),
      location_id: element.getAttribute('data-promo-position')
    };

    if (promoData.promotion_id || promoData.promotion_name) {
      gtag('event', event_name, promoData);
    }
  }

  function initPromotionTracking() {
    // 1. View Promotion Tracking (Intersection Observer)
    var observerOptions = {
      threshold: 0.5 // Trigger when 50% of the element is visible
    };

    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          trackPromotionEvent('view_promotion', entry.target);
          observer.unobserve(entry.target); // Track only once per page load
        }
      });
    }, observerOptions);

    // Initial search for promotions
    function observePromotions() {
      var promoElements = document.querySelectorAll('[data-promo-id]');
      promoElements.forEach(function(el) {
        observer.observe(el);
      });
    }

    observePromotions();

    // 2. Select Promotion Tracking (Click Event)
    document.addEventListener('click', function(event) {
      var promoElement = event.target.closest('[data-promo-id]');
      if (promoElement) {
        trackPromotionEvent('select_promotion', promoElement);
      }
    }, true);

    // Handle dynamically added content (like sliders or AJAX sections)
    var mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.hasAttribute('data-promo-id')) {
              observer.observe(node);
            }
            var childPromos = node.querySelectorAll('[data-promo-id]');
            childPromos.forEach(function(el) {
              observer.observe(el);
            });
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Wait for gtag to be ready
  var checkGtag = setInterval(function() {
    if (typeof gtag === 'function') {
      initPromotionTracking();
      clearInterval(checkGtag);
    }
  }, 500);
})();
